import { useEffect } from "react" 
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useFetchOrganisations } from "../hooks/OrganisationHooks";
import { OrganisationDTO } from "../types/organisationDTO";
import { useTranslation } from 'react-i18next';
import { useContext } from "react";
import { AuthContext } from "../AuthContext";

const OrganisationList = () => {
  const { t, i18n } = useTranslation();
  const nav = useNavigate();
  const { data, isPending, isError } = useFetchOrganisations();
  const { roles } = useContext(AuthContext);


useEffect(() => {
    if (isError) { nav('/login') }

}, [isError]);

  if (isPending) return <h2>Hold on</h2>;
  

  return (
    <div>
      <div className="row mb-2">
        <h5 className="subtitle text-left">
          {t('organisation.title')}
        </h5>
      </div>

      {roles.includes("SysAdmin") && (
        <Link className="btn btn-primary mt-2 mb-3" to="/organisation/add" >
          {t('organisation.add')}
        </Link>
      )}

        <table className="table table-hover"
            style={
                {
                    "--bs-table-hover-bg": "#C9DDED"
                } as React.CSSProperties
            }
        >
        <thead>
          <tr>
            {/* <th>Id</th> */}
            <th>{t('common.name')}</th>
            {/* <th>ValidFrom</th> */}
            {/* <th>ValidTo</th> */}
            <th>{t('common.lastModified')}</th>
          </tr>
        </thead>
        <tbody>
          {data &&
            data.sort((a, b) => a.name.localeCompare(b.name)).map((organisation: OrganisationDTO) => {
              const dateOptions: Intl.DateTimeFormatOptions = { 
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
              };

              return (
                  <tr key={organisation.id} style={{ cursor: 'pointer' }} onClick={() => nav(`/organisation/${organisation.id}`)}>
                  <td>{organisation.name}</td>
                  {/* <td>{validFrom.toLocaleString('fi-FI')}</td> */}
                  {/* <td>{validTo.toLocaleString('fi-FI')}</td> */}
                  <td>{new Date(organisation.lastModified + 'Z').toLocaleString(i18n.language === 'fi' ? 'fi-FI' : 'en-US', dateOptions)}</td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};

export default OrganisationList;
